import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { toursApiQueryKeys } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import toursApi from '@/features/dashboard/tours/api/toursApi.ts';
import { CancelTourRequest } from '@/features/dashboard/tours/types/CancelTourRequest.ts';

const useCancelTour = () => {
  const queryClient = useQueryClient();

  return useMutation<
    void,
    Error,
    { tourId: string; request: CancelTourRequest }
  >({
    mutationFn: ({ tourId, request }) => toursApi.cancelTour(tourId, request),
    onSuccess: (_, { tourId }) => {
      toast.success('Wyjazd został anulowany');
      queryClient.invalidateQueries({
        queryKey: toursApiQueryKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: toursApiQueryKeys.byId(tourId),
      });
      queryClient.invalidateQueries({
        queryKey: toursApiQueryKeys.cancellationReadiness(tourId),
      });
    },
    onError: (error: Error) => {
      toast.error('Nie udało się anulować wyjazdu', {
        description: error.message,
      });
    },
  });
};

export default useCancelTour;
